import { getClickAndReserveFeatureConfig } from '../FeatureConfigs/ClickAndReserve/utils.js';

const featureToggleLookup = {
    AAB: 'isAABEnabled',
    AAB_ALTERNATIVE_STORE_AVAILABILITY: 'isAabAlternativeStoreAvailabilityEnabled',
    ABTESTING: 'isABTestingEnabled',
    ADDRESSBOOK: 'isAddressBookEnabled',
    APPOINTMENT_BOOKING_TYPE_WITH_FREE_INDICATION: 'isAppointmentBookingTypeWithFreeIndication',
    BYNDER_IMAGES: 'isBynderImagesEnabled',
    CONTACTLENS_STOCK: 'isContactLensStockEnabled',
    CONTACTLENS: 'isContactLensEnabled',
    CART_DISCOUNTS: 'isCartDiscountsEnabled',
    CROSS_SELL: 'isCrossSellEnabled',
    DOWNLOAD_QUOTATION: 'isDownloadQuotationEnabled',
    GPS_STORES: 'isGpsStoresEnabled',
    HIDE_USER_DATA_FROM_ANALYTICS: 'isHideUserDataFromAnalyticsEnabled',
    LEGACY_ORDER_SUPPLIER_EAN: 'isLegacyOrderSupplierEanEnabled',
    MONETATE_PRODUCT_DATA: 'isMonetateProductDataEnabled',
    MULTI_COUNTRY_LOCATIONS: 'isMultiCountryLocationsEnabled',
    MULTILINGUAL: 'isMultilingualEnabled',
    MYACCOUNT: 'isMyAccountEnabled',
    OLAPIC_PROVIDER: 'isOlapicProviderEnabled',
    OMNI_VOUCHER: 'isOmniVoucherEnabled',
    PRODUCT_LABEL: 'isProductLabelEnabled',
    PERSISTENT_QUERY_DISABLED: 'isPersistentQueryDisabled',
    PRESCRIPTION_FILE: 'isPrescriptionFileEnabled',
    PRESCRIPTION_RECOGNITION: 'isPrescriptionRecognitionEnabled',
    PRESCRIPTION_GLASSES_CONFIGURATOR_VALIDATION_STEP: 'isPrescriptionGlassesConfiguratorValidationStepEnabled',
    PRESCRIPTION_GLASSES_REORDER: 'isPrescriptionGlassesReorderEnabled',
    PRESCRIPTION_GLASSES: 'isPrescriptionGlassesEnabled',
    REVIEWS: 'isReviewsEnabled',
    REORDER_BUTTON: 'isReorderButtonEnabled',
    STORE_SEARCH_SHOW_EMAIL: 'isStoreSearchEmailEnabled',
    STORE_SEARCH_SHOW_PHONE: 'isStoreSearchPhoneEnabled',
    STORE_DETAILS_SHOW_EMAIL: 'isStoreDetailsEmailEnabled',
    STORE_DETAILS_SHOW_PHONE: 'isStoreDetailsPhoneEnabled',
    STORE_PICKUP_SHOW_EMAIL: 'isStorePickupEmailEnabled',
    STORE_PICKUP_SHOW_PHONE: 'isStorePickupPhoneEnabled',
    STORE_RATINGS: 'isStoreRatingsEnabled',
    STORES_NEARBY: 'isStoresNearbyEnabled',
    STORES_PLACE_PREDICTIONS: 'isStoresPlacePredictionsEnabled',
    STORES_DISABLE_AAB_STORE_VALUE_AAB_BUTTON: 'isStoreValueInAabButtonDisabled',
    DELIVERY_FULL_DATE: 'isDeliveryFullDateEnabled',
    CART_RECOMMENDATIONS: 'isCartRecommendationsEnabled',
    VTO: 'isVtoEnabled',
    FRAME_SIZE_VTO: 'isFrameSizeVTOEnabled',
    APPLE_PAY_EXPRESS_CHECKOUT: 'isApplePayExpressCheckoutEnabled',
    PAYMENT_CALLBACK_API_ROUTE: 'isPaymentCallbackApiRouteEnabled',
    FEATURE_CHECKOUT_PAYMENT_PAGE_ENABLED: 'isCheckoutPaymentPageEnabled',
    CLICK_AND_RESERVE: 'isClickAndReserveEnabled',
    ENABLE_SOCIAL_LOGIN_FOR_CHECKOUT: 'isSocialLoginForCheckoutEnabled',
    LIME: 'isLimeEnabled',
    PRESCRIPTION_INFO: 'isPrescriptionInfoEnabled'
};
const createFeatureSet = (enabledEnvFeatures)=>{
    const enabledFeaturesSet = new Set(enabledEnvFeatures);
    const completeFeatureSet = {};
    Object.entries(featureToggleLookup).forEach(([key, mappedKey])=>{
        completeFeatureSet[mappedKey] = enabledFeaturesSet.has(key);
    });
    return completeFeatureSet;
};
/**
 * This function parses comma separated strings to arrays via the regular `split()`.
 * The benefit of this function is that it catches errors and removes empty values.
 */ const parseCommaSeparatedString = (string)=>{
    try {
        const array = string === null || string === void 0 ? void 0 : string.split(',') // Split comma separated string
        .map((value)=>value.trim()
        ).filter((value)=>value
        ) // Remove empty values
        ;
        return (array === null || array === void 0 ? void 0 : array.length) ? array : undefined;
    } catch (error) {
        console.error(`Error parsing feature config string '${string}': ${error}`);
    }
};
const parseIntBaseTen = (value)=>value !== undefined ? parseInt(value, 10) : undefined
;
var _SURVEY_LINK;
const createFeatureConfigs = (configs)=>{
    var ref, ref1;
    return {
        eyeExamConsentKey: configs.EYE_EXAM_CONSENT_KEY || 'eye-exam',
        datePickerDateFormat: configs.DATE_PICKER_DATE_FORMAT || 'MMMM d, yyyy',
        prescriptionTypesOrder: parseCommaSeparatedString(configs.PRESCRIPTION_TYPES_ORDER),
        prescriptionList: parseCommaSeparatedString(configs.PRESCRIPTION_LIST),
        configuratorUspsGroupTheme: configs.CONFIGURATOR_USPS_GROUP_THEME || 'light',
        maxSearchStoresResults: parseIntBaseTen(configs.MAX_SEARCH_STORES_RESULTS),
        maxNearbyStoresDistance: parseIntBaseTen(configs.MAX_NEARBY_STORES_DISTANCE_METERS),
        appointmentBookingUrlPaddedLength: parseIntBaseTen(configs.APPOINTMENT_BOOKING_URL_PADDED_LENGTH),
        appointmentBookingAvailabiltyCalendarWeekCount: parseIntBaseTen(configs.APPOINTMENT_BOOKING_AVAILABILITY_CALENDAR_WEEK_COUNT),
        appointmentBookingVirtualAppointmentTypeId: configs === null || configs === void 0 ? void 0 : configs.APPOINTMENT_BOOKING_VIRTUAL_APPOINTMENT_TYPE_ID,
        appointmentBookingVirtualAppointmentStoreCode: parseIntBaseTen(configs.APPOINTMENT_BOOKING_VIRTUAL_APPOINTMENT_STORE_CODE),
        appointmentBookingSurveyLinks: configs.APPOINTMENT_BOOKING_SURVEY_LINKS !== undefined ? Array.from(configs.APPOINTMENT_BOOKING_SURVEY_LINKS.matchAll(/([a-zA-Z-0-9]+)>([^\^]+)/g), ([, appointmentId, url])=>[
                appointmentId,
                url
            ]
        ) : undefined,
        appointmentBookingSurveyLinksStoreCodes: parseCommaSeparatedString(configs.APPOINTMENT_BOOKING_SURVEY_LINKS_STORE_CODES),
        surveyLink: (_SURVEY_LINK = configs.SURVEY_LINK) !== null && _SURVEY_LINK !== void 0 ? _SURVEY_LINK : undefined,
        appointmentBookingAlternativeUrl: configs.APPOINTMENT_BOOKING_ALTERNATIVE_URL,
        appointmentBookingAlternativeUrlStores: (ref = parseCommaSeparatedString(configs.APPOINTMENT_BOOKING_ALTERNATIVE_URL_STORES)) === null || ref === void 0 ? void 0 : ref.map((string)=>parseInt(string, 10)
        ),
        storeDistanceConfig: (ref1 = parseCommaSeparatedString(configs.STORE_DISTANCE_CONFIG)) === null || ref1 === void 0 ? void 0 : ref1.reduce((indexed, distanceProp)=>{
            indexed[distanceProp] = true;
            return indexed;
        }, {}),
        googleDynamicMapsMapId: configs.GOOGLE_DYNAMIC_MAPS_MAP_ID,
        clickAndReserve: getClickAndReserveFeatureConfig(configs.CLICK_AND_RESERVE),
        additionalLoginProviders: parseCommaSeparatedString(configs.ADDITIONAL_LOGIN_PROVIDERS),
        virtualTryOn: configs.VIRTUAL_TRY_ON || 'DITTO'
    };
};

export { createFeatureConfigs, createFeatureSet, parseCommaSeparatedString };
//# sourceMappingURL=utils.js.map
